module.exports = __webpack_public_path__ + "img/1521876808.61e79fd5.jpg";